// This address points to a dummy ERC-20 contract. Replace it with your own smart contracts.
const addresses = {
  "5": {
    ceaErc20: "0x4C0B6068562B1A46862BdC34A735A1696F59dB59",
    epochBase: "0x38406cfD6C9e3DB28541aA77ADcE5839c73CE4B6",
    uniswapV2Module: "0xB7e10cea2EBe3c440A85E4f8DdE3266A928e0217",
    aaveModule: "0xF62AF54E8734a6063ffdB99A7e8ac5f934ae4393",
    epochWalletRegistry: "0x7e30a5196FdC1490434D111797EA647b533c45A8",
  },
  "80001": {
    ceaErc20: "0xe1F541B98e0f3f39b8e144EC3d36C5b78c8E5539",
    epochBase: "0xd03F5F0e6321a4204c5903C573600962372D27Af",
    uniswapV2Module: "0x8B99eF88e25d4c789C5CA2696a2403e4eEAbCA21",
    aaveModule: "0x23982aF4e018DDb5fAc0EaBb361Ae7229202599D",
    epochWalletRegistry: "0x929008f87acA491BF063FDf764968B858093f259",
  },
  "420": {
    ceaErc20: "0x6D9D5e89248869D060689E54412472eC0E4d605a",
    epochBase: "0xFD245018A32d33d3788b58e6f9A1daA77d2A5829",
    uniswapV2Module: "0x626298be602107D73C8DD4Cdc18F3cdd9A935f51",
    aaveModule: "0x24Ca19260f1D20f951654Fb961334602f7828292",
    epochWalletRegistry: "0xcf2C5B89C9c4e445425f1180e361305A8c513795",
  },
  "647426021": {
    ceaErc20: "0x6D9D5e89248869D060689E54412472eC0E4d605a",
    epochBase: "0xFD245018A32d33d3788b58e6f9A1daA77d2A5829",
    uniswapV2Module: "0x626298be602107D73C8DD4Cdc18F3cdd9A935f51",
    aaveModule: "0x24Ca19260f1D20f951654Fb961334602f7828292",
    epochWalletRegistry: "0xcf2C5B89C9c4e445425f1180e361305A8c513795",
  },
  "338": {
    ceaErc20: "0xe1F541B98e0f3f39b8e144EC3d36C5b78c8E5539",
    epochBase: "0xd03F5F0e6321a4204c5903C573600962372D27Af",
    uniswapV2Module: "0x8B99eF88e25d4c789C5CA2696a2403e4eEAbCA21",
    aaveModule: "0x23982aF4e018DDb5fAc0EaBb361Ae7229202599D",
    epochWalletRegistry: "0x929008f87acA491BF063FDf764968B858093f259",
  },
  "1313161555": {
    ceaErc20: "0x6D9D5e89248869D060689E54412472eC0E4d605a",
    epochBase: "0xFD245018A32d33d3788b58e6f9A1daA77d2A5829",
    uniswapV2Module: "0x626298be602107D73C8DD4Cdc18F3cdd9A935f51",
    aaveModule: "0x24Ca19260f1D20f951654Fb961334602f7828292",
    epochWalletRegistry: "0xcf2C5B89C9c4e445425f1180e361305A8c513795",
  },
  "42261": {
    ceaErc20: "0x6D9D5e89248869D060689E54412472eC0E4d605a",
    epochBase: "0xFD245018A32d33d3788b58e6f9A1daA77d2A5829",
    uniswapV2Module: "0x626298be602107D73C8DD4Cdc18F3cdd9A935f51",
    aaveModule: "0x24Ca19260f1D20f951654Fb961334602f7828292",
    epochWalletRegistry: "0xcf2C5B89C9c4e445425f1180e361305A8c513795",
  },
};

export default addresses;
